<template>
  <SimpleStackedChart
    :name="$t('Chart__NumberOfDoctors__name')"
    :sheets="sheets"
  />
</template>

<script>
import data from '@/assets/json/NumberOfDoctors.json';
import SimpleStackedChart from '@/components/ChartPartials/SimpleStackedChart';

export default {
  name: 'NumberOfDoctors',
  components: {
    SimpleStackedChart
  },
  data() {
    return {
      sheets: data
    };
  }
};
</script>
